import { Module } from "vuex";

export const FeeTrackingTLM: Module<any, any> = {
  state: {
    queryFeeTrackingTLM: {
      company_ids: [], //
      cpn_code: [], //
      quarter: null, //
      year: null, //
      businessCpn: [],
      network_type: null,
      lic_number: [], //
      fromDay: null,
      toDay: null,
      statuses: [],
      isCheckCpn: false,
    },
  },
  getters: {
    queryFeeTrackingTLM: (state) => state.query,
  },
  mutations: {
    setqueryFeeTrackingTLM(state, data) {
      state.queryflowdata = data;
    },
  },
  actions: {
    setqueryFeeTrackingTLM(query) {
      query.commit("setqueryFeeTrackingTLM");
    },
  },
};
